/**
 * Centralized API Key Access - Sprint 15
 *
 * Single source of truth for all API keys.
 * Public app configuration only. Provider secrets must not use VITE_ because
 * Vite embeds those values in the browser bundle.
 */

export const apiKeys = {
  // External provider keys must be held server-side.
  googlePlaces: undefined as string | undefined,
  googleMaps: undefined as string | undefined,

  // Financial (Plaid)
  plaidClientId: undefined as string | undefined,
  plaidEdgeUrl: import.meta.env.VITE_PLAID_EDGE_FUNCTION_URL as string | undefined,

  // LLM providers are served through the Cloudflare Pages Worker proxy.
  // API keys live in Cloudflare secrets, not browser-visible VITE_* vars.
  anthropic: undefined as string | undefined,
  googleAi: undefined as string | undefined,
  groq: undefined as string | undefined,
  deepinfra: undefined as string | undefined,

  // Auth
  privyAppId: import.meta.env.VITE_PRIVY_APP_ID as string | undefined,

  // Mission agent provider keys are proxied server-side before enabling.
  serpapi: undefined as string | undefined,
  ticketmaster: undefined as string | undefined,
  newsApi: undefined as string | undefined,

  // Monitoring
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
} as const;

export type ApiKeyName = keyof typeof apiKeys;

export function isApiConfigured(key: ApiKeyName): boolean {
  const value = apiKeys[key];
  return typeof value === 'string' && value.length > 0;
}
